<template>
    <div id="ceremony" class="section">
        <span v-if="language==='EN'">
            <PageTitle :title="'Master of Ceremony'" :subtitle="'CREATIVE WORKS'" :description="''" />
            <p class="mt-4">The acting profession has many facets, faces, and means of expression….among my favorites: writing scenes and scenarios, organizing and hosting corporate events, weddings, holiday celebrations, presentations, and exhibitions. I love to be in front of a crowd, and the crowd loves me. I have been a professional "master of ceremonies" since 2006.</p>
            <p>Irreplaceable qualities of a successful MC are the ability to positively energize the public, feeling the emotion of the crowd, and respecting the boundaries of etiquette and taste.</p>
        </span>
        <span v-if="language==='RU'">
            <PageTitle :title="'Ведущая-конферансье'" :subtitle="'ТВОРЧЕСКИЕ МОМЕНТЫ'" :description="''" />
            <p class="mt-4">Актерская профессия багатогранна... Для меня, одна из самых любимых её граней – написание сценариев, организация и проведение корпоративных шоу-програм, свадебных и новогодних праздников, презентаций, выставок. Я люблю публику и отвечает мне взаимностью... Профессионально занимаюсь проведением мероприятий с 2006 года.</p>
            <p>Гарантия успеха ведущего-конферансье: позитивно заряжающая энергетика и чувство меры.</p>
        </span>
        <span v-if="language==='UA'">
            <PageTitle :title="'Ведуча-конферансьє'" :subtitle="'ТВОРЧІ МОМЕНТИ'" :description="''" />
            <p class="mt-4">Акторська професія багатогранна... Для мене, одна з улюблених ії граней – написання сценарію, організація і проведення корпоративних шоу-програм, весільних та новорічних свят, презентацій, виставок. Я люблю публіку і вона відповідає взаємністю... Професійно займаюся проведенням заходів з 2006 року.</p>
            <p>Запорука успіху ведучого-конферансьє: позитивно-заряджаюча енергетика і відчуття міри.</p>
        </span>
        <ImageShooter :directory="'ceremony'" :quantity="27" />
    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle'
    import { MyFunctions } from '@/data/functions.js'
    import ImageShooter from '@/components/ImageShooter'

    export default {
        components: { PageTitle, ImageShooter },
        data: () => ({
            language: 'EN'
        }),
        mounted(){
            this.language = MyFunctions.getLanguage()
        },
    }
</script>

<style>
    #ceremony h2 {
        font-size:30px!important
    }
</style>


